import { FormFieldPropertyObjectTypesIds } from 'forms-utils-lib/constants/PropertyObjectTypes';
const isCompanyField = formField => formField.objectTypeId === FormFieldPropertyObjectTypesIds.COMPANY;
export default isCompanyField;